<template>
    <div class="profile-settings-container">
        <!-- Background Shapes -->
        <div class="background-shapes">
            <div class="shape triangle-1"></div>
            <div class="shape triangle-2"></div>
            <div class="shape circle"></div>
        </div>

        <!-- Breadcrumb and Heading -->
        <div class="content-wrapper">
            <Breadcrumb :crumbs="breadcrumbs"/>
            <h3 class="text-center" id="heading">{{ $t('Profile Settings') }}</h3>
            <!-- Form Wizard -->
            <div class="form-wizard">
                <form-wizard @on-complete="onComplete" color="#077747" ref="formWizard" :hide-buttons="loading">
                    <tab-content :title="$t('Step 1')" icon="ti-user">
                        <ProfileStepOne v-model:formData="formData.userProfile" ref="stepOne"/>
                    </tab-content>

                    <tab-content :title="$t('Step 2')" icon="ti-settings">
                        <ProfileStepTwo :formData="formData" @update:formData="formData = $event" ref="stepTwo"/>
                    </tab-content>

                    <tab-content :title="$t('Step 3')" icon="ti-check">
                        <ProfileStepThree v-model:formData="formData.parentInfo" ref="stepThree"/>
                    </tab-content>

                    <tab-content :title="$t('Step 4')" icon="ti-check">
                        <ProfileStepFour
                                :formData="formData"
                                @update-child-info="formData.childInfo = $event"
                                @update-spouse-info="formData.spouseInfo = $event"
                                @update-sibling-info="formData.siblingInfo = $event"
                                ref="stepFour"/>
                    </tab-content>

                    <tab-content :title="$t('Step 5')" icon="ti-check">
                        <ProfileStepFive :formData="formData"
                                         @update-bank-info="formData.bankInfo = $event"
                                         @update-wealth-info="formData.wealthInfo = $event"
                                         @update-receivable-info="formData.receivableInfo = $event"
                                         @update-payable-info="formData.payableInfo = $event"
                                         ref="stepFive"/>
                    </tab-content>
                    <span v-if="loading" class="spinner-border spinner-border-sm" role="status"
                          aria-hidden="true"></span>
                </form-wizard>
            </div>
        </div>
    </div>
</template>

<script>
    import {FormWizard, TabContent} from 'vue3-form-wizard';
    import Breadcrumb from "../partials/Breadcrumb.vue";
    import ProfileStepOne from "./ProfileSetup/ProfileStepOne.vue";
    import ProfileStepTwo from "./ProfileSetup/ProfileStepTwo.vue";
    import ProfileStepThree from "./ProfileSetup/ProfileStepThree.vue";
    import ProfileStepFour from "./ProfileSetup/ProfileStepFour.vue";
    import ProfileStepFive from "./ProfileSetup/ProfileStepFive.vue";
    import apiRepository from "@/services/ApiRepository";
    import {toast} from "vue3-toastify";

    export default {
        name: "ProfileComponent",
        components: {
            Breadcrumb,
            FormWizard,
            TabContent,
            ProfileStepOne,
            ProfileStepTwo,
            ProfileStepThree,
            ProfileStepFour,
            ProfileStepFive,
        },
        data() {
            return {
                breadcrumbs: [
                    {text: this.$t("Home"), path: "/"},
                    {text: this.$t("Profile"), path: "/admin/profile"},
                ],
                loading: false,
                address: "",
                email: '',
                file: '',
                place_of_birth: '',
                all_country: '',
                userAllDataGet: [],
                formData: {
                    userProfile: {
                        firstName: '',
                        lastName: '',
                        gender: '',
                        professionId: '',
                        district: '',
                        maritalStatusId: '',
                        passportNo: '',
                        nationality: '',
                        citizenship: '',
                        multipleCitizenPassportNo: '',
                        multipleCitizenCode: '',
                        tin: '',
                        nid: '',
                        profileFile: [],
                        tinFile: [],
                        nidFile: [],
                        citizenFile: [],
                        presentAddress: "",
                        permanentAddress: "",
                        overseasCountryCode: '',
                        overseasVillage: '',
                    },
                    parentInfo: {
                        parentId: '',
                        userId: '',
                        fatherName: '',
                        fatherProfessionId: '',
                        fatherNationalityId: '',
                        fatherNID: '',
                        fatherNIDUrl: '',
                        fatherWhatsAppNumber: '',
                        fatherExisting: '',
                        motherName: '',
                        motherProfessionId: '',
                        motherNationalityId: '',
                        motherNID: '',
                        motherNIDUrl: '',
                        motherWhatsAppNumber: '',
                        motherExisting: '',
                        fatherNIDFile: '',
                        motherNIDFile: ''
                    },
                    spouseInfo: [
                        {
                            siblingId: '',
                            siblingName: '',
                            genderId: '',
                            professionId: '',
                            nationalityId: '',
                            nid: '',
                            dob: '',
                            existing: '',
                            nidPaperUrl: '',
                            whatsAppNumber: '',
                            email: '',
                            mobile: '',
                            socialMediaLink: '',
                            userId: '',
                            nidFile: ''
                        }
                    ],
                    siblingInfo: [
                        {
                            siblingId: '',
                            siblingName: '',
                            genderId: '',
                            professionId: '',
                            nationalityId: '',
                            nid: '',
                            dob: '',
                            existing: '',
                            nidPaperUrl: '',
                            whatsAppNumber: '',
                            email: '',
                            mobile: '',
                            socialMediaLink: '',
                            userId: '',
                            nidFile: '',
                        }
                    ],
                    childInfo: [
                        {
                            childId: '',
                            childName: '',
                            genderId: '',
                            professionId: '',
                            nationalityId: '',
                            dob: '',
                            nid: '',
                            nidPaperUrl: '',
                            mobile: '',
                            email: '',
                            existing: '',
                            userId: '',
                            nidFile: '',
                        }
                    ],
                    bankInfo: [
                        {
                            userBankInfoId: '',
                            userId: '',
                            bankId: '',
                            branchId: '',
                            bankAccNo: '',
                            accBalance: '',
                        }
                    ],
                    wealthInfo: [
                        {
                            userId: '',
                            wealthId: '',
                            documentTypeId: '',
                            documentPaperUrl: '',
                            amount: '',
                            location: '',
                            note: '',
                            documentFile: '',
                        }
                    ],
                    receivableInfo: [
                        {
                            recId: '',
                            userId: '',
                            receivableAmount: '',
                            receivablePerson: '',
                            receivablePersonMobile: '',
                        }
                    ],
                    payableInfo: [
                        {
                            payId: '',
                            userId: '',
                            payableAmount: '',
                            payablePerson: '',
                            payablePersonMobile: '',
                        }
                    ],

                }
            };
        },

        mounted() {
        },
        methods: {
            validateFormData() {
                const errors = [];

                const userProfile = this.formData.userProfile;
                const parentInfo = this.formData.parentInfo;
                // const bankInfo = this.formData.bankInfo?.[0];
                // const wealthInfo = this.formData.wealthInfo?.[0];

                if (!userProfile.firstName) errors.push("First Name is required");
                if (!userProfile.lastName) errors.push("Last Name is required");
                if (!userProfile.gender) errors.push("Gender is required");
                if (!userProfile.nid) errors.push("NID is required");
                if (!userProfile.nationality) errors.push("Nationality is required");
                if (!userProfile.maritalStatusId) errors.push("Marital Status is required");

                if (!parentInfo.fatherName) errors.push("Father Name is required");
                if (!parentInfo.fatherNID) errors.push("Father NID is required");
                if (!parentInfo.motherName) errors.push("Mother Name is required");
                if (!parentInfo.motherNID) errors.push("Mother NID is required");

                // if (!bankInfo?.bankId) errors.push("Bank is required");
                // if (!bankInfo?.branchId) errors.push("Bank Branch is required");
                // if (!bankInfo?.bankAccNo) errors.push("Bank Account No is required");
                //
                // if (!wealthInfo?.amount) errors.push("Wealth amount is required");
                // if (!wealthInfo?.location) errors.push("Wealth location is required");

                // this.formData.receivableInfo.forEach((item, i) => {
                //     if (!item.receivableAmount || !item.receivablePerson || !item.receivablePersonMobile) {
                //         errors.push(`Receivable info ${i + 1} is incomplete`);
                //     }
                // });
                //
                // this.formData.payableInfo.forEach((item, i) => {
                //     if (!item.payableAmount || !item.payablePerson || !item.payablePersonMobile) {
                //         errors.push(`Payable info ${i + 1} is incomplete`);
                //     }
                // });

                return errors;
            },
            onComplete() {
                this.loading = true;
                try {

                    const validationErrors = this.validateFormData();

                    if (validationErrors.length > 0) {
                        validationErrors.forEach(error => toast.error(error));
                        return;
                    }

                    apiRepository.saveProfileData(this.formData).then((response) => {
                        if (response) {
                            toast.success("Successfully Inserted Data!")
                        } else {
                            toast.error(response.data || 'error')
                        }
                    })
                } catch (e) {
                    console.error('error', e);
                    toast.error("Unexpected error occurred!");
                } finally {
                    this.loading = false;
                }
            },

        },
    };
</script>

<style scoped>
    .profile-settings-container {
        position: relative;
        padding: 2rem;
        background: linear-gradient(135deg, #f5f7fa, #c3cfe2);
        border-radius: 15px;
        overflow: hidden;
        min-height: 100vh;
    }

    .background-shapes {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
    }

    .shape {
        position: absolute;
        background: rgba(255, 255, 255, 0.3);
    }

    .triangle-1 {
        width: 0;
        height: 0;
        border-left: 100px solid transparent;
        border-right: 100px solid transparent;
        border-bottom: 200px solid rgba(255, 99, 71, 0.3);
        top: -50px;
        left: -50px;
        transform: rotate(45deg);
    }

    .triangle-2 {
        width: 0;
        height: 0;
        border-left: 80px solid transparent;
        border-right: 80px solid transparent;
        border-bottom: 160px solid rgba(70, 130, 180, 0.3);
        bottom: -80px;
        right: -80px;
        transform: rotate(-30deg);
    }

    .circle {
        width: 150px;
        height: 150px;
        border-radius: 50%;
        background: rgba(144, 238, 144, 0.3);
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .content-wrapper {
        position: relative;
        z-index: 2;
        /*background: rgba(255, 255, 255, 0.9);*/
        padding: 2rem;
        border-radius: 10px;
        /*box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);*/
        animation: fadeIn 0.5s ease-in-out;
    }

    #heading {
        margin-bottom: 1.5rem;
        font-size: 1.8rem;
        color: #333;
    }

    .form-wizard {
        margin-top: 1.5rem;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(-20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
</style>
